import React, { useState } from "react";
import logoWhatsapp from "../../assets/logoWhatsapp.png";
import "./whatsapp.scss";
import WhatsAppModal from "./WhatsAppModal";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { buildWhatsAppUrl, getUtmParams, getCurrentUrlWithUtmDefaults } from "../../config/whatsappConfig";
import { sendToTecnom } from "../../config/tecnomApi";

const WHATSAPP_MODAL_PHONE = "5493517385093";

const WhatsAppFlotante = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      const utms = getUtmParams();
      await updateData({
        ...values,
        ...utms,
        url: getCurrentUrlWithUtmDefaults(),
      });
      setOpen(false);
      const urlWithUtm = getCurrentUrlWithUtmDefaults();

      const whatsappMessage = `'Hola, estoy viendo opciones en Automont Hyundai y quiero tomar una mejor decisión , ¿me orientás?'\n${urlWithUtm}`;

      try {
        await sendToTecnom({
          brand: "HYUNDAI",
          name: values.nombre,
          email: values.email,
          phone: values.celular,
          comments: "Consulta desde modal de WhatsApp",
          tipoPlan: "venta directa",
          ...utms,
          campaign: "HYUNDAI_WHATSAPP_MODAL",
        });
      } catch (tecnomError) {
        console.error("Error al enviar a Tecnóm:", tecnomError);
      }

      window.location.href = buildWhatsAppUrl(whatsappMessage, WHATSAPP_MODAL_PHONE);
    } catch (error) {
      console.error("Modal WhatsApp — error al guardar en Firestore:", error);
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="whatsapp-container">
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
      <button className="btn-whatsapp-flotante" onClick={() => setOpen(true)} disabled={loading}>
        <img src={logoWhatsapp} alt="whatsapp" />
      </button>
    </div>
  );
};
export default WhatsAppFlotante;
